import BaseResource from './index'
import SchoolResource from './school'
import DeveloperProfileResource from './developerprofile'

export default class EducationResource extends BaseResource {
    static endpoint = '/education'

    static get related() {
        return {
            profile: DeveloperProfileResource,
            school: SchoolResource
        }
    }

    isElite() {
        return this.readonly.school_priority > 80
    }

    toPrettyName() {
        let attrs = this.attributes
        let value = '' 

        if(attrs.degree) {
            value += attrs.degree.toUpperCase()
        }

        if(attrs.concentration) {
            value += ` ${attrs.concentration}`
        }

        if(this.readonly.school_name && this.readonly.school_name.length) {
            value += `, ${this.readonly.school_name}`
        }

        return value
    }

    get dateSpanPretty() {
        let bits = [this.attributes.start_year, this.attributes.end_year].filter((value) => value)
        return bits.join(' to ')
    }

    toString() {
        return this.toPrettyName()
    }
}
